module.exports = __webpack_public_path__ + "img/p12.24936e93.png";